import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { site } from "@/mocks/site";

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200 bg-background-50/90 backdrop-blur-md"
          : "border-b border-transparent bg-background-50/40 backdrop-blur"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="group flex items-center gap-2.5" aria-label="吃瓜路线 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-colors group-hover:bg-primary-600">
            <i className="ri-node-tree text-lg" aria-hidden="true"></i>
          </span>
          <span className="leading-none">
            <span className="block font-heading text-lg font-bold tracking-wide text-foreground-950">
              {site.name}
            </span>
            <span className="mt-0.5 block text-[10px] uppercase tracking-[0.22em] text-accent-600">
              事件地图 · 线索串联
            </span>
          </span>
        </Link>

        {/* 桌面导航 */}
        <div className="hidden items-center gap-1 md:flex">
          {site.nav.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm transition-colors ${
                location.pathname === item.path
                  ? "bg-primary-50 font-semibold text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/events"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-fire-fill" aria-hidden="true"></i>
            去围观热榜
          </Link>
        </div>

        {/* 移动端按钮 */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 md:hidden">
          <div className="flex flex-col">
            {site.nav.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`rounded-md px-3 py-3 text-base ${
                  location.pathname === item.path
                    ? "bg-primary-50 font-semibold text-primary-700"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/events"
              className="mt-3 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-fire-fill" aria-hidden="true"></i>
              去围观热榜
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}